// Test IDs for major interactive and content elements
export const HOME = {
  // nav
  navHome: "nav-link-home",
  navAbout: "nav-link-about",
  navSchedule: "nav-link-schedule",
  navMinistries: "nav-link-ministries",
  navSacraments: "nav-link-sacraments",
  navConstruction: "nav-link-construction",
  navContact: "nav-link-contact",
  mobileMenuToggle: "mobile-menu-toggle",
  // hero
  heroCtaSchedule: "hero-cta-schedule",
  heroCtaConstruction: "hero-cta-construction",
  // construction
  constructionProgressBar: "construction-progress-bar",
  constructionContactCta: "construction-contact-cta",
  // contact
  contactNameInput: "contact-name-input",
  contactEmailInput: "contact-email-input",
  contactConcernSelect: "contact-concern-select",
  contactMessageInput: "contact-message-input",
  contactSubmit: "contact-submit-button",
  contactSuccess: "contact-success-message",
  // footer
  footer: "site-footer",
  topButton: "scroll-top-button",
};

export const ADMIN = {
  loginPasswordInput: "admin-login-password",
  loginSubmit: "admin-login-submit",
  logoutButton: "admin-logout-button",
  tabInquiries: "admin-tab-inquiries",
  tabAnnouncements: "admin-tab-announcements",
  tabConstruction: "admin-tab-construction",
  // inquiries
  inquiryRow: "admin-inquiry-row",
  inquiryStatusSelect: "admin-inquiry-status",
  inquiryDelete: "admin-inquiry-delete",
  // announcements
  announcementBadgeInput: "admin-announcement-badge",
  announcementTitleInput: "admin-announcement-title",
  announcementBodyInput: "admin-announcement-body",
  announcementSubmit: "admin-announcement-submit",
  announcementDelete: "admin-announcement-delete",
  // construction
  constructionPercentInput: "admin-construction-percent",
  constructionPhaseInput: "admin-construction-phase",
  constructionNoteInput: "admin-construction-note",
  constructionSave: "admin-construction-save",
};
